import { apiClient } from '../client/apiClient';
import { ENDPOINTS } from '../config/endpoints';

export interface AppFeatures {
  smartReport: boolean;
}

export interface AppConfig {
  features: AppFeatures;
}

export const configService = {
  getConfig: () => apiClient.get<AppConfig>(ENDPOINTS.CONFIG.GET),
};
